import svgUrl from "ni:svgr;l0T7rWtKRf8vNxqA0Xby5EGNjGrIejWMmzYXB0SoA7k";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const EnrichmentClearbitLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path d="M2 6C2 3.79086 3.79086 2 6 2H16V30H6C3.79086 30 2 28.2091 2 26V6Z" fill="var(--tbl--ui-node-icon--enrichment--clearbit-primary)" /><path d="M30 6C30 3.79086 28.2091 2 26 2H16V16H30V6Z" fill="var(--tbl--ui-node-icon--enrichment--clearbit-secondary)" /><path d="M30 26C30 28.2091 28.2091 30 26 30H16V16H30V26Z" fill="var(--tbl--ui-node-icon--enrichment--clearbit-tertiary)" /></svg>;
const Memo = memo(EnrichmentClearbitLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "EnrichmentClearbitLIcon";
}